<template>
    <button class="btn" type="button" :class="btnClass" ref="okay">
        <icon v-if="icon" :name="icon" viewBox="0 0 24 24" />
        <span v-if="hasSlot">
            <slot />
        </span>
        <span v-if="label && ! hasSlot">{{ label }}</span>
    </button>
</template>

<script>
export default
{
    name: 'Action',

    props:
    {
        color: String,
        icon: String,
        label: String,

        mobile:
        {
            type: Boolean,
            default: false,
        },

        mobileOnly:
        {
            type: Boolean,
            default: false,
        },

        focus:
        {
            type: Boolean,
            default: false
        }
    },

    computed:
    {
        /**
         * Return btn class
         * @returns {string}
         */
        btnClass()
        {
            let _return = [];

            if (this.color)
                _return.push('btn--' + this.color.replace('btn--', ''));

            if (this.mobile)
                _return.push('btn--icon-only');

            if (this.icon)
                _return.push('btn-' + this.icon);

            if (this.mobileOnly)
                _return.push('btn--icon-only-mobile');

            return _return.join(' ');
        },

        /**
         * Show slot if defined
         * @returns {boolean}
         */
        hasSlot()
        {
            return (typeof this.$slots.default !== 'undefined');
        },
    },

    mounted()
    {
        if (this.focus)
        {
            this.$refs.okay.focus()
        }
    }
}
</script>



// WEBPACK FOOTER //
// Action.vue?1acbd90e